'use strict';
angular.module('threeViewer.controllers', ['threeViewer.services'])

  // Control that manages changes to the 3d scene
.controller('SceneControl', ['$scope', '$rootScope', 'ModelFactory', 'CameraService', 'SceneService',
    function ($scope, $rootScope, ModelFactory, CameraService, SceneService) {

        $scope.manager = {};

        $scope.controls = {};

        $scope.webgl_detect = true;

        $scope.addModel = function () {
            ModelFactory.addModel($scope.cow3D);
        }

        $scope.toggleRotate = function(objName) {
          if(!$scope.controls.autoRotate) {
            $scope.controls.reset();
          };
          $scope.controls.autoRotate = !$scope.controls.autoRotate;
          $scope.controls.update();
        }

        // brings camera out
        $scope.increaseCameraZ = function () {
            CameraService.perspectiveCam.position.z += 2;
        }

        //brings camera in
        $scope.decreaseCameraZ = function () {
            CameraService.perspectiveCam.position.z -= 2;
        }

        $scope.$watch('model3D',function(val) {
          ModelFactory.moveModel(val);
        },true);

        //$scope.addModel();

    }]);



// WEBPACK FOOTER //
// ./src/app/js/threeControllers.js